<template>
  <Output :kokubanDataList="kokubanDataList" :currentConstruction="currentConstruction" />
</template>

<script>
import store from '../../../store'

export default {
  name: 'KokubanOutput',
  components: {
    Output: () => import('../../../components/cloud/CreKokuban/ConstructionFolder/Output.vue')
  },
  props: {
    currentConstruction: Object
  },
  computed: {
    kokubanDataList() {
      // awsからの取得結果を返す
      return this.$store.getters['aws/result/curKokubanDataList'];
    }
  },
  beforeRouteEnter(to, from, next) {
    // 黒板リスト取得
    const args = {
      cloud_construction_id: to.params.cloudConstructionId
    };
    store.dispatch('api/getKokubanDataList', args).then((apiResult) => {
      if (store.getters['api/apiError']) {
        next(false);
        return;
      }
      const aws_args = {
        cloud_construction_id: to.params.cloudConstructionId,
        kokubandata_list: apiResult
      }
      store.dispatch('aws/kokubanDataListOf', aws_args).then(() => {
        if (store.getters['api/apiError']) {
          next(false);
          return;
        }
        next();
      });
    });
  }
}
</script>

<style scoped>
</style>